import styled from '@emotion/styled';

const SectionHeader = styled('h2')({
  marginTop: '1.25rem',
});

export default SectionHeader;
